let listeners = []


const subscribe = (fn) => {
  listeners.push(fn)
}

const unsubscribe = (fn) => {
  listeners = listeners.filter((listener) => listener !== fn)
}

const dispatch = (match) => {
  listeners.forEach((listener) => listener(match))
}


export default {
  subscribe,
  unsubscribe,
  dispatch,
}
